





















































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import ToolsHelper from '@core/services/tools.helper';
import {
  ShoppingCartDiscount,
  ShoppingCartOrderDetail,
  ShoppingCartProduct,
} from '@accounting/interfaces/shopping-cart';

@Component({
  name: 'bpc-shopping-cart-product-item',
  components: {},
})
export default class ShoppingCartProductItem extends Vue {
  @Prop(Object) readonly shoppingCartProduct: ShoppingCartProduct;
  @Prop({ type: Boolean, default: true }) readonly value: boolean;

  get model(): boolean {
    return this.value;
  }

  set model(value) {
    this.$emit('input', value);
  }

  public errorText: string = 'global.generic.error_form_action';

  currentImgField = 'defaultConversionUrl';
  imgFail = false;

  onImgError() {
    console.log('inImgError', this.currentImgField);
    if (this.currentImgField === 'img_url') {
      this.imgFail = true;
    }
    if (this.currentImgField === 'url') {
      this.currentImgField = 'img_url';
    }
    if (this.currentImgField === 'defaultConversionUrl') {
      this.currentImgField = 'url';
    }
  }

  get imgUrl() {
    const fallBackImg = this.$store.getters['centerSettings/backgroundUrl']
      ? this.$store.getters['centerSettings/backgroundUrl']
      : this.$store.getters['centerSettings/logoUrl']
      ? this.$store.getters['centerSettings/logoUrl']
      : null;

    if (this.imgFail) {
      return fallBackImg;
    }

    // return this.shoppingCartProduct.imgUrl;
    return this.shoppingCartProduct.media_image[this.currentImgField]
      ? this.shoppingCartProduct.media_image[this.currentImgField]
      : fallBackImg;
  }

  public formatPrice(value) {
    return ToolsHelper.formatPrice(value);
  }

  public getDiscountVariant(discount: ShoppingCartDiscount): string {
    switch (discount.status) {
      case 'draft':
        return 'warning';
      case 'cancelled':
        return 'danger';
      case 'confirmed':
        return 'success';
      default:
        return 'primary';
    }
  }

  public onCancel(order: ShoppingCartOrderDetail) {
    this.$emit('cancel-product-order', order);
  }

  @Watch('model')
  onModelChange(val) {
    if (val) {
      this.$emit('product-selected', this.shoppingCartProduct);
    } else {
      this.$emit('product-deselected', this.shoppingCartProduct);
    }
  }
}
